// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Auth from "../../bundles/Auth/Auth.res.js";
import * as Notifier from "../../bundles/Notifier/Notifier.res.js";
import * as Navigation from "../../primitives/Navigation.res.js";
import * as OrderRoutes from "./OrderRoutes.res.js";
import * as Stdlib_List from "@rescript/runtime/lib/es6/Stdlib_List.js";
import * as OrderListPage from "./OrderListPage.res.js";
import * as AccessDeniedPage from "../Error/AccessDeniedPage.res.js";
import * as Notifier__Context from "../../bundles/Notifier/Notifier__Context.res.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as OrderEditContainer from "./OrderEditContainer.res.js";
import * as OrderUrlQueryString from "../../modules/Order/OrderUrlQueryString.res.js";

function OrderRouter(props) {
  let userRole = Auth.useRole();
  let url = Navigation.useUrl();
  let match = OrderUrlQueryString.CreateOrder.decode(url.query);
  if (!Auth.isAuthorizedAccess(userRole, OrderRoutes.baseRoute)) {
    return JsxRuntime.jsx(AccessDeniedPage.make, {});
  }
  let match$1 = Stdlib_List.fromArray(url.path);
  let tmp;
  let exit = 0;
  if (match$1 !== 0) {
    let exit$1 = 0;
    if (match$1.hd === "orders") {
      let match$2 = match$1.tl;
      if (match$2 !== 0) {
        let id = match$2.hd;
        if (id === "create") {
          if (match$2.tl !== 0) {
            exit = 1;
          } else {
            tmp = JsxRuntime.jsx(OrderEditContainer.make, {
              supplierId: match[0],
              shopId: match[1]
            });
          }
        } else if (match$2.tl !== 0) {
          exit = 1;
        } else {
          tmp = JsxRuntime.jsx(OrderEditContainer.make, {
            id: id
          });
        }
      } else {
        exit$1 = 2;
      }
    } else {
      exit$1 = 2;
    }
    if (exit$1 === 2) {
      if (match$1.tl !== 0) {
        exit = 1;
      } else {
        tmp = JsxRuntime.jsx(OrderListPage.make, {});
      }
    }
  } else {
    exit = 1;
  }
  if (exit === 1) {
    tmp = JsxRuntime.jsx(Navigation.Redirect.make, {
      route: OrderRoutes.baseRoute
    });
  }
  return JsxRuntime.jsx(Notifier__Context.Provider.make, {
    value: Notifier.createContext(),
    children: tmp
  });
}

let make = OrderRouter;

export {
  make,
}
/* Auth Not a pure module */
